import { useEffect, useRef, useState } from 'react';
import { RemoteAudioTrack, Room, RoomEvent, Track } from 'livekit-client';

/**
 * Toca o som que vem junto com a tela compartilhada.
 *
 * Existe porque faltava: o app coletava apenas as faixas de video
 * (`Track.Source.ScreenShare`) para montar a grade. O som viaja numa faixa
 * separada, `ScreenShareAudio`, que era assinada normalmente e depois
 * descartada — ninguem a anexava a lugar nenhum. Resultado: quem assistia nao
 * ouvia nada, sem nenhum erro aparecer.
 *
 * Os elementos ficam invisiveis; audio nao precisa de interface. O que precisa
 * de interface e o bloqueio de reproducao automatica, tratado abaixo.
 */

export function ScreenAudio({ room }: { room: Room }) {
  const [bloqueado, setBloqueado] = useState(!room.canPlaybackAudio);

  useEffect(() => {
    const aoMudar = () => setBloqueado(!room.canPlaybackAudio);
    room.on(RoomEvent.AudioPlaybackStatusChanged, aoMudar);
    return () => {
      room.off(RoomEvent.AudioPlaybackStatusChanged, aoMudar);
    };
  }, [room]);

  const faixas: { key: string; track: RemoteAudioTrack }[] = [];
  for (const participante of room.remoteParticipants.values()) {
    for (const pub of participante.trackPublications.values()) {
      if (pub.source === Track.Source.ScreenShareAudio && pub.track && pub.isSubscribed) {
        faixas.push({ key: pub.trackSid, track: pub.track as RemoteAudioTrack });
      }
    }
  }

  // A propria faixa nao entra: ouvir o proprio audio de volta e eco puro.
  return (
    <>
      {faixas.map((f) => (
        <ElementoDeAudio key={f.key} track={f.track} />
      ))}

      {bloqueado && faixas.length > 0 && (
        <button className="btn btn-primary audio-bloqueado" onClick={() => void room.startAudio()}>
          Ativar o som da transmissao
        </button>
      )}
    </>
  );
}

function ElementoDeAudio({ track }: { track: RemoteAudioTrack }) {
  const ref = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [track]);

  return <audio ref={ref} autoPlay hidden />;
}
